// Global BOOK namespace for all JS
if (typeof BOOK == 'undefined') var BOOK = {};